// extracted by mini-css-extract-plugin
export var fadeInOut = "_1b-3";
export var icon = "_1b-4";
export var savedIndicator = "_1b-2";
export var savingIndicator = "_1b-0";
export var spin = "_1b-1";